const MuiButtonBase = {
  defaultProps: {
    disableRipple: true,
  },
};

export default MuiButtonBase;
